var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('keep-alive',{staticClass:"main-content",attrs:{"include":_vm.includeList,"exclude":_vm.excludeList}},[_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"min-height":"98%","height":"100%","width":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }